var React = require('react');

function LoadingIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Atomico_logo_White"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M60,30C60,13.4,46.6,0,30,0C13.4,0,0,13.4,0,30c0,16.6,13.4,30,30,30c5.4,0,10.7-1.5,15.4-4.3c3.5,1.6,7.6,0,9.1-3.5\n\t\tc0.7-1.6,0.8-3.5,0.2-5.2C58.2,42,60,36.1,60,30z M50.1,42.7c-3.7-1.1-7.5,1.1-8.6,4.7c-0.3,1.1-0.4,2.3-0.1,3.4\n\t\tC29.9,57.2,15.4,53,9,41.4S6.9,15.4,18.5,9s26.1-2.1,32.4,9.5C55,26.1,54.7,35.4,50.1,42.7z","key":0}),React.createElement("path",{"d":"M30,18.2c-6.5,0-11.8,5.3-11.8,11.8S23.5,41.8,30,41.8S41.8,36.5,41.8,30c0,0,0,0,0,0C41.8,23.5,36.5,18.2,30,18.2\n\t\tC30,18.2,30,18.2,30,18.2z","key":1})])]);
}

LoadingIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 60 60","style":{"enableBackground":"new 0 0 60 60"},"xmlSpace":"preserve"};

module.exports = LoadingIcon;

LoadingIcon.default = LoadingIcon;
